module.exports = __webpack_public_path__ + "static/fonts/Nunito-ExtraLightItalic.92874aa.woff2";